module.exports = __webpack_public_path__ + "static/e-banquet-illu-3-386a2949a6076855127d7180113ff8a0.png";